import { UserRole } from "../../enums";
export var hasAdminRole = function (user) {
    if (user.role) {
        return user.role === UserRole.admin;
    }
    // legacy
    return user.roles.indexOf(UserRole.admin) > -1;
};
export var hasManagerRole = function (user) {
    if (user.role) {
        return user.role === UserRole.manager;
    }
    // legacy
    return user.roles.indexOf(UserRole.manager) > -1 && !hasAdminRole(user);
};
export var hasSuperAdminRole = function (user) {
    if (user.role) {
        return user.role === UserRole.superAdmin;
    }
    // legacy
    return user.roles.indexOf(UserRole.superAdmin) > -1 && !hasAdminRole(user);
};
export var hasDeactivatedRole = function (user) {
    return user.roles.length === 0 || user.role === UserRole.deactivated;
};
